import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { isEmpty } from 'libraries/lodash'
import cx from 'classnames'
import Button from '@material-ui/core/Button'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import selectCurrentSearchType from 'redux/selectors/selectCurrentSearchType'
import SearchMenu from './SearchMenu'
import Icon from 'components/shared/Icon'

const DropDownSearchMenu = ({ searchTypeClasses }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const buttonRef = useRef()

  const currentSearchType = useSelector(selectCurrentSearchType)
  const handleOnClick = event => setAnchorEl(event.currentTarget)
  const handleOnFocus = () => isEmpty(anchorEl) && buttonRef.current.blur()
  useEffect(() => setAnchorEl(null), [currentSearchType])

  return (
    <div className='h-100 w-auto'>
      <Button
        ref={buttonRef}
        onFocus={handleOnFocus}
        aria-controls='customized-menu'
        aria-haspopup='true'
        variant='contained'
        color='primary'
        className='search-drop-down-menu'
        classes={{ root: cx('br0 h-100 outline-0 ph4 ph0-m min-w9-m pv2', searchTypeClasses), contained: 'shadow-none' }}
        onClick={handleOnClick}
      >
        <Icon className='w7 vm white' name='icon-filter-outline-variant' />
        <ArrowDropDownIcon className='w6 w5-m white' />
      </Button>
      <SearchMenu {...{ anchorEl, setAnchorEl }} />
    </div>
  )
}

export default DropDownSearchMenu
